import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { TYPE_OPTIONS } from '@/data';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles } from '@/styles';
import { PersonalisationType } from '@/types';

/**
 * @element fg-personalisation-choose-type
 */
@customElement('fg-personalisation-choose-type')
@localized()
export class FgPersonalisationChooseType extends LitElement {
  private options = TYPE_OPTIONS;

  private chooseType(type: PersonalisationType) {
    this.dispatchEvent(
      new CustomEvent('personalisation-choose-type', {
        detail: { type },
      }),
    );
  }

  render() {
    return html`
      ${this.options.map(
        option => html`
          <button @click=${() => this.chooseType(option.type)}>
            ${option.icon}
            <div>
              <strong>${t(option.titleTranslationKey)}</strong>
              <span>${t(option.descriptionTranslationKey)}</span>
            </div>
          </button>
        `,
      )}
    `;
  }

  static styles = [
    baseStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      svg {
        flex-shrink: 0;
      }

      button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        background: white;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        flex-grow: 1;
        flex-basis: 100%;
        transition: border;
      }
      button:hover,
      button:focus {
        border-color: var(--fg-primary, var(--fg-fallback-primary));
        box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
      }

      strong {
        margin-bottom: 2px;
        font-size: 1rem;
      }

      strong,
      span {
        display: block;
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        :host {
          flex-direction: row;
        }

        button {
          padding: 14px 8px 20px;
          flex-direction: column;
          text-align: center;
        }
      }
    `,
  ];
}
